import AXIOS from "./axios";

export class FaceRecognition {
  static enroll({ image }) {
    return AXIOS.post("auth/faces/enroll", { image });
  }

  static recognize({ image }) {
    return AXIOS.post("auth/faces/verify", { image });
  }
}
